export default __webpack_public_path__ + "static/media/FR.109-Raporlama-Sistemi-Müşteri-Bilgilendirme-Formu.d95795d9.pdf";